import React, { Component } from 'react';
import { connect } from 'react-redux';
import Cookies from 'universal-cookie';
import { withRouter } from 'react-router-dom';
import qs from 'query-string';
import Loader from '../components/loader';
import TokenService from "../services/tokenService";

const cookies = new Cookies();

class Oauth extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { user } = this.props;
    const urlParams = qs.parse(this.props.location.search);

    let code = '';
    if (urlParams && urlParams.code) {
      code = urlParams.code;
    }
    let kyc;
    if (urlParams && urlParams.kyc) {
      kyc = urlParams.kyc;
    }

    const plaintext = cookies.get('_vtotmp');

    if (!code || !plaintext) {
      return window.location.href = '/';
    }

    const postUrl = process.env.REACT_APP_OAUTH_POST_URL || `http://identity.local:3192/oauth/token`;
    const postBody = {
      code,
      code_verifier: plaintext,
      grant_type: 'authorization_code',
      redirect_uri: process.env.REACT_APP_OAUTH_REDIRECT_URI,
      client_id: process.env.REACT_APP_OAUTH_CLIENT_ID,
      client_secret: process.env.REACT_APP_OAUTH_CLIENT_SECRET,
    };

    var formBody = [];
    for (var property in postBody) {
      var encodedKey = encodeURIComponent(property);
      var encodedValue = encodeURIComponent(postBody[property]);
      formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");

    const requestMetadata = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        'Accept': 'application/json'
      },
      body: formBody
    };

    fetch(postUrl, requestMetadata)
    .then(response => {
      if (response.ok) {
        response.json().then(json => {
          let accessToken = '';
          let refreshToken = '';
          if (json && json.access_token) {
            accessToken = json.access_token;
          }
          if (json && json.refresh_token) {
            refreshToken = json.refresh_token;
          }
          const key = '_vto';
          const cookieKey = '_vtoa';
          const secure = false;

          const cookieData = {
            access_token: accessToken,
            refresh_token: refreshToken,
          };

          cookies.set(cookieKey, JSON.stringify(cookieData), { hostname: process.env.REACT_APP_HOSTNAME, path: '/', secure });

          if (accessToken) {
            TokenService.updateLocalAccessToken(accessToken);
          }
          if (refreshToken) {
            TokenService.updateLocalRefreshToken(refreshToken);
          }
          cookies.remove('_vtotmp');
          if (kyc) {
            return window.location.href = '/kyc';
          }
          return window.location.href = '/';
        });
      }
      else {
        window.location.href = '/login?logged=true'
      }
    });
  }

  render() {
    const { errors, success, user, loggingIn } = this.props;
    return (
      <div className="center-loader">
        <Loader logo />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  token: state.user.token,
  user: state.user,
  errors: state.user.errors,
  success: state.user.success,
});

export default withRouter(connect(mapStateToProps)(Oauth));
